import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useAuth } from '../stores/auth';
import { authedFetch } from '../lib/supabase';

/**
 * FinancialFirewall — blocks non-financial roles (VOM, therapist, read_only_auditor)
 * from reaching financial routes (KPI, A/R, import). Audit-logs the attempt before
 * redirecting to /restricted?reason=financial.
 *
 * Allowed roles: org_admin, super_admin.
 */
export function FinancialFirewall({ children }) {
  const { profile, loading, initialized } = useAuth();
  const location = useLocation();
  const loggedRef = useRef(false);

  const role = profile?.role;
  const allowed = role === 'org_admin' || role === 'super_admin';

  useEffect(() => {
    if (!initialized || loading) return;
    if (!profile) return;
    if (allowed) return;
    if (loggedRef.current) return;
    loggedRef.current = true;
    authedFetch('/audit/log-access-denied', {
      method: 'POST',
      body: JSON.stringify({ reason: 'financial', path: location.pathname }),
    }).catch((err) => { console.warn('Access-denied audit log failed:', err); });
  }, [allowed, initialized, loading, location.pathname, profile]);

  if (!initialized || loading) return null;
  if (!allowed) {
    return <Navigate to="/restricted?reason=financial" replace />;
  }
  return children;
}
